import {
    AddressFieldConfig,
    CustomerFields,
    FieldConfig
} from '../types/config';

/**
 * Extract the value from a FieldConfig or return the string directly
 */
export const getFieldValue = (
    field: string | FieldConfig | undefined
): string | undefined => {
    if (!field) {
        return undefined;
    }
    if (typeof field === 'string') {
        return field;
    }
    return field.value;
};

/**
 * Check if a field is visible (defaults to true if not specified)
 */
export const isFieldVisible = (
    field: string | FieldConfig | undefined
): boolean => {
    if (!field) {
        return true;
    }
    if (typeof field === 'string') {
        return true;
    }
    return field.visible !== false;
};

/**
 * Extract plain address values from AddressFieldConfig
 */
export interface PlainAddress {
    line1?: string;
    line2?: string;
    city?: string;
    postalCode?: string;
    state?: string;
    country?: string;
}

export const getPlainAddress = (
    address?: AddressFieldConfig
): PlainAddress | undefined => {
    if (!address) {
        return undefined;
    }

    return {
        line1: getFieldValue(address.line1),
        line2: getFieldValue(address.line2),
        city: getFieldValue(address.city),
        postalCode: getFieldValue(address.postalCode),
        state: getFieldValue(address.state),
        country: getFieldValue(address.country)
    };
};

/**
 * Extract plain customer data values from CustomerFields
 */
export interface PlainCustomerData {
    name?: string;
    email?: string;
    address?: PlainAddress;
}

export const getPlainCustomerData = (
    fields?: CustomerFields
): PlainCustomerData => {
    if (!fields) {
        return {};
    }

    return {
        name: getFieldValue(fields.name),
        email: getFieldValue(fields.email),
        address: getPlainAddress(fields.address)
    };
};
